import { ThemeOptions } from '@mui/material';

const darkThemeOptions: ThemeOptions = {};

export default darkThemeOptions;
